import { OrderFieldsCreateResp } from '@api/responseModels/orderFields/orderFieldsCreateResponse';
import { OrderFieldsResp } from '@api/responseModels/orderFields/orderFieldsResponse';
import { RequestResult } from '@api/responseModels/requestResult';

import { CRMAPIBase } from '../../crmApiBase';

class OrderFieldCategoriesGroup extends CRMAPIBase {
    async getOrderFieldCategories(): Promise<RequestResult<OrderFieldsResp>> {
        const result = await this.get<OrderFieldsResp>(`admin/order-field-groups`);
        return result;
    }

    async getFieldCategory(params: {
        entity_id: number;
    }): Promise<RequestResult<OrderFieldsCreateResp>> {
        const result = await this.get<OrderFieldsCreateResp>(
            `admin/order-field-groups/${params.entity_id}`
        );
        return result;
    }

    async createFieldCategory(params: {
        name: string;
        category_id: number;
    }): Promise<RequestResult<OrderFieldsCreateResp>> {
        const result = await this.post<OrderFieldsCreateResp>(`admin/order-field-groups`, {
            ...params,
        });
        return result;
    }

    async updateFieldCategory(params: {
        entity_id: number;
        name: string;
        category_id: number;
        orderFields: number[];
    }): Promise<RequestResult<OrderFieldsResp>> {
        console.log(params);
        const result = await this.put<OrderFieldsResp>(
            `admin/order-field-groups/${params.entity_id}`,
            {
                ...params,
            }
        );
        return result;
    }

    async deleteFieldCategory(entity_id: number): Promise<RequestResult<OrderFieldsCreateResp>> {
        const result = await this.delete<OrderFieldsCreateResp>(
            `admin/order-field-groups/${entity_id}`
        );
        return result;
    }
}

export { OrderFieldCategoriesGroup };
